<!-- QuickPlan Main -->
<template>
  <el-container class="is-vertical">
    <AppHeader></AppHeader>
    <UpdatePassword></UpdatePassword>
    <el-container>
      <AppSidebar></AppSidebar>
      <el-main style="overflow-x:hidden;" :class="bgClass">
        <router-view/>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import UpdatePassword from '@/components/UpdatePasword'
export default {
  name: 'Main',
  components: {
    AppHeader,
    AppSidebar,
    UpdatePassword
  },
  watch: {
    $route () {
      this.setTitle()
    }
  },
  created () {
    this.setTitle()
  },
  computed: {
    bgClass: function () {
      return this.$route.path.indexOf('guide') > -1 ? 'guideBg' : ''
    }
  },
  methods: {
    // 當 route 切換時，將設定於 vue-route 中的標題寫入頁籤 title
    setTitle () {
      document.title = this.$route.meta.title ? `${this.$route.meta.title}` : 'QuickPlan AI受眾觸及規劃師'
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/global.scss';
#app {
  display: flex;
}
.el-main {
  overflow-x: hidden;
  height: auto;
  padding-left: 264px;
  margin-top: 48px;
  background-color: map-get($globalVariable, MainBackgroundColor);
  color: #4a4a4a;
}
.el-container {
  height:100%;
  overflow-y: auto;
}

.guideBg{
  background-image: url(../assets/images/bg3.jpg);
}
.guideBg.el-main{
    /*不讓導引流程受影響*/
    padding: 24px;
    height: calc( 100vh - 48px );
  }
  .option_item{
    height:80px;
    text-align: center;
    margin:20px auto 0px;
    box-shadow: 0 4px 10px 0 rgba(199, 199, 199, 0.5);
    background-color: #ffffff;
    border:2px solid #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1.5;
    transition:  0.5s;
    cursor:pointer;
    overflow:hidden;
    position: sticky;

  }
  .option_item:hover{
    border:2px solid #DFEFFF;
    color:#4da1ff;
    font-weight:bold;
  }
  .option_item:after{
    width: 100%;
    height: 0;
    top: 50%;
    left: 50%;
    background-color:#DFEFFF;
    opacity: 0;
    transform: translateX(-50%) translateY(-50%) rotate(45deg);
    content: '';
    position: absolute;
    z-index: -1;
    transition: all 0.3s;
  }
  .option_item:hover:after{
    height: 400%;
    opacity: 1;
  }

  .option_item.active{
    border:2px solid #4da1ff;
    color:#4da1ff;
    font-weight:bold;
  }
  .option_item.option_item-small{
    width:100%;
  }
  .option_item_text{
    flex-grow: 1;
  }
  .option_item_icon{
    margin-left:24px;
    font-size:32px;
    margin-right:-48px;
    color:#c6c6c6;
  }
  .option_item.active .option_item_icon,.option_item:hover .option_item_icon{
    color:#4da1ff;
  }

</style>
